import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/auth';
import * as api from '../services/api';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
import { browserHistory } from 'react-router';
import { load, loaded } from '../ducks/loading';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let toastId = '';

function* userLogin(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/login', action.data);
    console.log('res.data======>', res.data);
    if (res.status == 'success') {
      localStorage.setItem('authToken', res.data.t);
      localStorage.setItem('username', res.data.fn ? res.data.fn : res.data.un);
      localStorage.setItem('e', res.data.e);
      localStorage.setItem('pvd', 'local');

      //if user not login 
      // window.location.href = res.data.rp ? res.data.rp : '/dashboard';
      window.location.href = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=list';

      //without login create widet, after login remove cookie
      cookies.remove('Ifrm_data');
    }
    else if (res.status == 'not_found') {
      yield put(loaded());
      if (!toast.isActive(toastId)) {
        toastId = toast.error(res.m);
      }
      // yield put(actions.userLoginError(true));
      // setTimeout(() => {
      //   window.location.href = process.env.REACT_APP_WISERNOTIFY_DOMAIN;
      // }, 1000);
    }
    else if (res.status == 'not_active') {
      yield put(loaded());
      if (!toast.isActive(toastId)) {
        toastId = toast.error(res.m);
      }
      // setTimeout(() => {
      //   window.location.href = process.env.REACT_APP_WISERNOTIFY_DOMAIN;
      // }, 1000);
    }
  }
  catch (error) {
    yield put(loaded());
    yield put(actions.userLoginError(true));
    setTimeout(() => {
      window.location.href = process.env.REACT_APP_WISERNOTIFY_DOMAIN;
    }, 1000);
  }
}

function* userReset(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/rPassword', action.data);
    if (res.status == 'success') {
      window.location.href = process.env.REACT_APP_ROUTE_PREFIX + 'login?reset=true';
      //browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'login');
    }
    else if (res.status == 'duplicate') {
      if (!toast.isActive(toastId)) {
        toastId = toast.info(res.m);
      }
    }
    else if (res.status == 'not_found') {
      if (!toast.isActive(toastId)) {
        toastId = toast.info(res.m);
      }
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.resetError(true));
  }
}

function* forgetPD(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/fPassword', action.data);
    if (res.status == 'success') {
      //window.location.href = '/login';
      browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'login');
      toast.success(res.m);
    }
    else if (res.status == 'not_found') {
      if (!toast.isActive(toastId)) {
        toastId = toast.error(res.m);
      }
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.forgetPDError(true));
  }
}

function* signup(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/register', action.data);
    if (res.status == 'success') {
      localStorage.setItem('authToken', res.data.token);
      localStorage.setItem('username', res.data.fn ? res.data.fn : res.data.username);
      localStorage.setItem('e', res.data.e);
      localStorage.setItem('pvd', 'local');
      // window.location.href = res.data.rp;
      window.location.href = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=list';

      //without login create widet, after login remove cookie
      cookies.remove('Ifrm_data');
    }
    else if (res.status == 'duplicate') {
      yield put(loaded());
      if (!toast.isActive(toastId)) {
        toastId = toast.info(res.m);
      }
    }
  } catch (error) {
    yield put(loaded());
    yield put(actions.signupError(true));
  }
}

function* getProfile() {
  let res;
  try {
    if (localStorage.getItem('userTyp') == 'instafeed') {
      yield put(actions.getProfileError(true));
      return;
    }
    //yield put(load());
    res = yield call(api.GET, '/getProfile');
    if (res.status == 'success') {
      if (res.data.ia !== false) {
        yield put(actions.getProfileSuccess(res.data));
        if (res.data && res.data.addonqty !== undefined && res.data.addonqty != 0) {
          localStorage.setItem('W_FR_USR_WD', false);
        }
        else {
          localStorage.setItem('W_FR_USR_WD', true);
        }
        if (res.data && res.data.isbusr && res.data.isbusr == true) {
          localStorage.setItem('W_FR_USR_WD', false);
        }
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('username');
        localStorage.removeItem('e');
        localStorage.removeItem('pvd');
        window.location.href = process.env.REACT_APP_ROUTE_PREFIX;
      }
    }
    else {
      yield put(actions.getProfileError(true));
      toast.error('Error in get user profile');
    }
    //yield put(loaded());
  } catch (error) {
    if (error && error.message !== 'Failed to fetch') {
      localStorage.removeItem('authToken');
      localStorage.removeItem('username');
      localStorage.removeItem('e');
      localStorage.removeItem('pvd');
      window.location.href = process.env.REACT_APP_ROUTE_PREFIX;
    }
    yield put(actions.getProfileError(true));
  }
}



export function* watchUserLogin() {
  yield takeEvery(actions.LOGIN, userLogin);
}

export function* whatchUserReset() {
  yield takeEvery(actions.RESET, userReset);
}

export function* whatchSignup() {
  yield takeEvery(actions.SIGNUP, signup);
}

export function* whatchForgetPD() {
  yield takeEvery(actions.FORGETPD, forgetPD);
}

export function* whatchGetProfile() {
  yield takeEvery(actions.GET_PROFILE, getProfile);
}



export default function* rootSaga() {
  yield [
    fork(watchUserLogin),
    fork(whatchUserReset),
    fork(whatchSignup),
    fork(whatchForgetPD),
    fork(whatchGetProfile)
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js